/**
 * @flow
 * @relayHash 08af171599de363d1845f1eee5549a18
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReceiverPermissions = "CAN_CLASSIFY_DESTINATION" | "CAN_EDIT_FULL_ADDRESS" | "UNDEFINED" | "%future added value";
export type PackageTrackerAddressUpdateMutationInput = {|
  packageId: number,
  addressData?: ?AddressData,
  addressComplement: string,
  clientMutationId?: ?string,
|};
export type AddressData = {|
  formattedAddress: string,
  types?: ?$ReadOnlyArray<?string>,
  placeId?: ?string,
  addressComplement?: ?string,
  addressComponents: $ReadOnlyArray<?AddressComponent>,
  geometry?: ?Geometry,
  partialMatch?: ?boolean,
|};
export type AddressComponent = {|
  types?: ?$ReadOnlyArray<?string>,
  shortName?: ?string,
  longName?: ?string,
|};
export type Geometry = {|
  locationType?: ?string,
  location?: ?Position,
  viewport?: ?Viewport,
  bounds?: ?Bound,
|};
export type Position = {|
  lat: number,
  lng: number,
|};
export type Viewport = {|
  northeast?: ?Position,
  southwest?: ?Position,
  east?: ?number,
  south?: ?number,
  west?: ?number,
  north?: ?number,
|};
export type Bound = {|
  east?: ?number,
  south?: ?number,
  west?: ?number,
  north?: ?number,
|};
export type confirmEditionMutationVariables = {|
  input: PackageTrackerAddressUpdateMutationInput
|};
export type confirmEditionMutationResponse = {|
  +packageTrackerAddressUpdate: ?{|
    +success: ?boolean,
    +privatePackageTracker: ?{|
      +packageInfo: ?{|
        +companyName: ?string,
        +packageId: ?number,
      |},
      +recipientInfo: ?{|
        +firstName: ?string,
        +originalPhone: ?string,
      |},
      +destinationInfo: ?{|
        +firstLine: ?string,
        +secondLine: ?string,
        +complement: ?string,
        +coordinates: ?{|
          +lat: number,
          +lng: number,
        |},
      |},
      +permissions: ?$ReadOnlyArray<ReceiverPermissions>,
    |},
  |}
|};
export type confirmEditionMutation = {|
  variables: confirmEditionMutationVariables,
  response: confirmEditionMutationResponse,
|};
*/

/*
mutation confirmEditionMutation(
  $input: PackageTrackerAddressUpdateMutationInput!
) {
  packageTrackerAddressUpdate(input: $input) {
    success
    privatePackageTracker {
      packageInfo {
        companyName
        packageId
      }
      recipientInfo {
        firstName
        originalPhone
      }
      destinationInfo {
        firstLine
        secondLine
        complement
        coordinates {
          lat
          lng
        }
      }
      permissions
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'PackageTrackerAddressUpdateMutationInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTrackerAddressUpdate',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'PackageTrackerAddressUpdateMutation',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'privatePackageTracker',
            storageKey: null,
            args: null,
            concreteType: 'PrivateTrackerResultNode',
            plural: false,
            selections: [
              {
                kind: 'LinkedField',
                alias: null,
                name: 'packageInfo',
                storageKey: null,
                args: null,
                concreteType: 'TrackerPackageInfoNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'companyName',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'packageId',
                    args: null,
                    storageKey: null
                  }
                ]
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'recipientInfo',
                storageKey: null,
                args: null,
                concreteType: 'PrivateTrackerRecipientInfoNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'firstName',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'originalPhone',
                    args: null,
                    storageKey: null
                  }
                ]
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'destinationInfo',
                storageKey: null,
                args: null,
                concreteType: 'PrivateTrackerDestinationInfoNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'firstLine',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'secondLine',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'complement',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'LinkedField',
                    alias: null,
                    name: 'coordinates',
                    storageKey: null,
                    args: null,
                    concreteType: 'PointNode',
                    plural: false,
                    selections: [
                      {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'lat',
                        args: null,
                        storageKey: null
                      },
                      {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'lng',
                        args: null,
                        storageKey: null
                      }
                    ]
                  }
                ]
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'permissions',
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'confirmEditionMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'confirmEditionMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'confirmEditionMutation',
      id: null,
      text:
        'mutation confirmEditionMutation(\n  $input: PackageTrackerAddressUpdateMutationInput!\n) {\n  packageTrackerAddressUpdate(input: $input) {\n    success\n    privatePackageTracker {\n      packageInfo {\n        companyName\n        packageId\n      }\n      recipientInfo {\n        firstName\n        originalPhone\n      }\n      destinationInfo {\n        firstLine\n        secondLine\n        complement\n        coordinates {\n          lat\n          lng\n        }\n      }\n      permissions\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '18adb3ea2ff1ddc09d9398a2be44c736';
module.exports = node;
